import { useMutation } from '@apollo/client';
import React from 'react';
import localLogout from '../account/localLogout';
import useAppSelector from '../app/redux/useAppSelector';
import Avatar from '../components/Avatar';
import PopOver from '../components/deprecated/PopOver';
import Menu, { MenuItem, MenuSeparator } from '../components/Menu';
import memberIcon from '../icons/member.svg';
import settingsIcon from '../icons/settings.svg';
import userPath from '../utils/url/userPath';
import { IS_CAPACITOR } from '../constants/platform';
import { gql } from '../graphql/generated/gql';

const LOGOUT_MUTATION = gql(`
  mutation logout {
    logout
  }
`);

const TopbarUserButton = () => {
  const currentUser = useAppSelector((state) => state.session.user);
  const [logoutMutate] = useMutation(LOGOUT_MUTATION);

  const handleLogout = () =>
    logoutMutate().finally(() => {
      localLogout(false);
    });

  return (
    // @ts-expect-error
    <PopOver
      popOver={
        <Menu>
          <MenuItem icon={memberIcon} to={userPath(currentUser)}>
            Profile
          </MenuItem>
          {!IS_CAPACITOR && (
            <>
              <MenuItem icon={settingsIcon} to="/settings">
                Settings
              </MenuItem>
              <MenuSeparator />
            </>
          )}
          <MenuItem onClick={handleLogout}>Log out</MenuItem>
        </Menu>
      }
      trigger="click"
      placement="bottom-end"
      responsivePlacement="bottom"
    >
      <Avatar user={currentUser} />
    </PopOver>
  );
};

export default TopbarUserButton;
